import { PaginatedData, PaginationConfig } from '../types/common';
import { Clearing } from '../types/Clearing';
import { apiFront } from './api';

export async function fetchClearings(
  params: PaginationConfig
): Promise<PaginatedData<Clearing>> {
  const response = await apiFront.get('/clearings', { params });
  return response.data;
  // return new Promise((resolve) => {
  //   resolve({
  //     data: [
  //       {
  //         id: 'liq_123456789',
  //         clearing_date: new Date().toISOString(),
  //         created_at: new Date().toISOString(),
  //         gross_amount: 10500.5,
  //         discounts_amount: 500.0,
  //         chargebacks_amount: 0,
  //         net_amount: 10000.5,
  //         status: 'cash_out_sent',
  //       },
  //       {
  //         id: 'liq_123456789',
  //         clearing_date: new Date().toISOString(),
  //         created_at: new Date().toISOString(),
  //         gross_amount: 10500.5,
  //         discounts_amount: 500.0,
  //         chargebacks_amount: 0,
  //         net_amount: 10000.5,
  //         status: 'cash_out_ok',
  //       },
  //       {
  //         id: 'liq_987654321',
  //         clearing_date: new Date(Date.now() - 86400000).toISOString(),
  //         created_at: new Date(Date.now() - 86400000).toISOString(),
  //         gross_amount: 5200.0,
  //         discounts_amount: 200.0,
  //         chargebacks_amount: 1000.0,
  //         net_amount: 4000.0,
  //         status: 'cash_out_failed',
  //       },
  //     ],
  //     total_pages: 1,
  //     total_elements: 3,
  //     current_page: '1',
  //     page: 1,
  //     per_page: params.per_page || 10,
  //   });
  // });
}

export function getClearingExcelUrl(id: string): string {
  return `${apiFront.defaults.baseURL}clearings/${id}/export-transactions`;
}

export function getClearingPdfUrl(id: string): string {
  return `${apiFront.defaults.baseURL}clearings/${id}/download-pdf`;
}
